import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { routes } from '../../app/routes.constant';
import { LoginService } from '../../common/components/login/login.service';
import { nodeTypes } from '../../app/app-constant';
import { UserService } from '../../common/services/user.service';
import { TagsService } from '../../common/services/tags.service';
import { environment } from '../../environments/environment';
import { Title } from "@angular/platform-browser";
import { authCookieName } from '../../app/app-constant';

let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
let footerLinks = {
  ONLINE_SECURITY: 'https://www.hsbc.com/online-security',
  HSBC_GROUP: 'https://www.hsbc.com/',
  CUSTOMER_SUPPORT: 'https://www.hsbcnet.com/gbm/customer-support',
  TERMS_AND_CONDITIONS: 'https://www1.secure.hsbcnet.com/uims/portal/TermsConditions',
  PRIVACY_AND_DATA: 'https://www1.secure.hsbcnet.com/uims/portal/DataProtection',
  HSBCNET_CONDITIONS: 'https://www1.secure.hsbcnet.com/uims/portal/NLSConditions'
};

@Component({
  selector: 'app-digital-hub',
  templateUrl: './digital-hub.component.html',
  styleUrls: ['./digital-hub.component.css']
})
export class DigitalHubComponent implements OnInit {

  applications = [
    {name: 'My Applications', enabled: true},
    {name: 'Application Marketplace', enabled: false}
  ];
  activeApp = 0;
  lastModified = new Date().getDate()+' '+months[new Date().getMonth()]+' '+new Date().getFullYear()+' '+new Date().getHours()+':'+new Date().getMinutes();
  authCheck = false;
  authSuccess = false;
  userRole;
  showMoreInfo = false;
  userDataError = '';
  hsbcNetUrl: string;
  isIE = /*@cc_on!@*/false || !!document.documentMode;
  displayName;
  userDataSubscription: any;
  footerLinks = footerLinks;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private loginService: LoginService, private userService: UserService, 
    private tagsService: TagsService, private title: Title) { }

  ngOnInit() {
    let that = this;
    this.title.setTitle('Security Services Applications');
    this.displayName = this.userService.displayName;
    this.hsbcNetUrl = this.userService.hsbcNetUrl;
    //let jwtToken: any = this.userService.getCookie(authCookieName);
    //if(jwtToken) {
      this.loginService.jwtAuth();
      setTimeout(function() {that.getUserData()}, 2500);
    // } else {
    //   that.authCheck = true;
    //   that.authSuccess = false;
    // }
    /* this.activatedRoute.queryParams.subscribe(params => {
      if(params.saml) {
        that.loginService.loggedIn = 'Y';
        that.userService.nodeType = 'ROLE_CUSTOMER';

        this.loginService.loginAuth({'saml': params.saml})
          .subscribe( res => {
            that.userRole = res.role;

            if([nodeTypes.ADMIN, nodeTypes.CUSTOMER].indexOf(res.role) > -1) {
              if(res.role == nodeTypes.CUSTOMER) {
                that.getUserData();
              }
            } else {
              that.samlAuth = false;
            }
          },
          error => {
            that.samlAuth = false;
          });
      } else {
        that.samlAuth = false;
      }
    }); */

    this.userDataSubscription = this.userService.userDataSub.subscribe(
      (val) => {
        //console.log('userDataSubscription', val)
        if(val == 'Y') {
          that.displayName = that.userService.displayName;
        }
      }
    );
  }

  ngOnDestroy() {
    this.userDataSubscription.unsubscribe();
  }

  navigateToHoldings(newWindow = true) {
    //this.router.navigate([routes.HOLD_TRANSACTIONS_HOLDINGS]);
    
    //let landingRoute = this.loginService.getLandingRoute();
    //this.router.navigate([landingRoute]);
    //this.router.navigate([]).then(result => {  window.open(window.location.origin, '_blank'); });
    if(this.userService.getCookie('username')) {
      this.loginService.loggedIn = 'Y';
      console.log(newWindow);
      if(newWindow) {
        window.open(window.location.origin, '_blank');
      } else {
        this.router.navigate([routes.HOLD_TRANSACTIONS_HOLDINGS]);
        //window.open(window.location.origin, '_self');
      }
    } else {
      window.location.href = this.userService.hsbcNetUrl;
    }
  }

  getUserData(): void {
    let that = this;
    this.loginService.getUserData(true, false)
      .subscribe( res => {
          /* let landingRoute = this.loginService.getLandingRoute();
          this.router.navigate([landingRoute]); */
          that.authCheck = true;
          that.authSuccess = true;
		    },
        error => {
          that.userDataError = error;
          //this.cordaError = error;
          //console.log(error);
          //that.authFail = true;
          that.authCheck = true;
          that.authSuccess = false;
        });
  }

  footerLinksNavigate(footerItem) {
    window.open(this.footerLinks[footerItem], '_blank');
  }

  closeSecService() {
    let that = this;
    this.loginService.logout()
      .subscribe( res => {
          //console.log(res);
          //this.router.navigate(['/login']);
          window.location.href = that.userService.hsbcNetUrl;
        },
        error => {
          //console.log(error);
          window.location.href = that.userService.hsbcNetUrl;
        });

    this.tagsService.link({
      "event_action" : "button click",
      "event_content": "digital hub : close"
    });
  }

}
